import React from 'react'
import { Card, Button } from 'react-bootstrap'


const ChartCard = (props) => {
  const { chart, onClick, chartViewButtonText } = props

  let modifiedDate, chartReviewerRole

  if (chart.modified_date) {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
    modifiedDate = new Date(chart.modified_date).toLocaleDateString(undefined, options)
  }

  if (chart.chart_reviewer_role_other_other_text) {
    chartReviewerRole = chart.chart_reviewer_role_other_other_text
  } else {
    chartReviewerRole = chart.chart_reviewer_role
  }

  return (
    <Card className="ChartCard">
      <Card.Header>
        <span className='chart-card-header'>Patient ID:</span> {chart.patient_identifier}
      </Card.Header>

      <Card.Body>
        <Card.Text>
          <span className='chart-card-header'>Chart Reviewer ID:</span> {chart.chart_reviewer}
        </Card.Text>

        <Card.Text>
          <span className='chart-card-header'>Chart Reviewer Role:</span> {chartReviewerRole}
        </Card.Text>

        {chart.site && typeof chart.site === 'object' && Object.keys(chart.site) ?
          <>
            <Card.Text>
              <span className='chart-card-header'>Country:</span> {chart.site.country}
            </Card.Text>

            <Card.Text>
              <span className='chart-card-header'>Site:</span> {' '}
              {chart.site.number} - {chart.site.name}
            </Card.Text>
          </>
          :
          null
        }

        <Card.Text>
          <span className='chart-card-header'>Last Modified:</span> {modifiedDate}
        </Card.Text>
      </Card.Body>

      <Card.Footer>
        <center>
          <Button onClick={onClick}>
            {chartViewButtonText || "View Chart"}
          </Button>
        </center>
      </Card.Footer>
    </Card>
  )
}

export default ChartCard
